<template>
    <div id="main">
        <div class="page">
            <div class="tipos-servicos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('adiantamentos') }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a>{{ $t('despesas') }}</a>
                                </li>
                                <li>
                                    <router-link
                                        :to="{ name: 'des-adiantamentos' }"
                                        aria-current="page"
                                        >{{ $t('adiantamentos') }}</router-link
                                    >
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <!-- FILTROS -->
                <div class="search-and-filter">
                    <div class="columns is-variables is-desktop">
                        <div class="column header-search is-2">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                                tooltipLabel="msg-campo-busca-acertos"
                                width="40"
                            />
                        </div>
                        <div class="column is-3">
                            <!-- :dateType="'default'"-->
                            <verified-date-picker
                                v-model="date"
                                :placeholder="'selecione-uma-data'"
                                :subtractDateYears="5"
                            />
                        </div>
                        <div class="column is-3">
                            <verified-date-picker
                                :dateType="'startDate'"
                                v-model="startDate"
                                :endDate="endDate"
                                :title="'data-inicio'"
                                :placeholder="'selecione-uma-data'"
                                @carregarDados="carregarDados()"
                            />
                        </div>
                        <div class="column is-3">
                            <verified-date-picker
                                :dateType="'endDate'"
                                v-model="endDate"
                                :startDate="startDate"
                                :title="'data-fim'"
                                :placeholder="'selecione-uma-data'"
                                @carregarDados="carregarDados()"
                            />
                        </div>
                        <!-- SITUACAO -->
                        <div v-show="false" class="situacao-select column is-2">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                            </v-select>
                        </div>
                    </div>
                </div>
                <!--Tabela-->
                <section class="registry-wrapper mt-2">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message class="mt-3" v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="adiantamentos"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <!--COLOCAR OS LABELS PARA OS DICIONARIOS -->
                        <b-table-column
                            v-for="f in fields"
                            :key="f.key + '-' + f.colaborador"
                            :field="f.key"
                            :label="f.key == 'deletar' ? '' : $t(f.key)"
                            :class="{ 'excluir-field': f.key == 'deletar' }"
                            :width="f.width"
                            :sortable="f.sortable"
                            v-slot="props"
                        >
                            <div class="has-text-left" v-if="f.key == 'colaborador'">
                                <router-link
                                    :to="{
                                        name: 'des-adiantamento',
                                        params: { id: props.row.idadiantamento },
                                    }"
                                >
                                    {{ props.row.colaborador }}
                                </router-link>
                            </div>

                            <div v-else-if="f.key == 'valor'">
                            {{ getDecimal(props.row.valor, null, true) }}
                            </div>

                            <div v-else-if="f.key == 'data'">
                                <span v-if="props.row.data">
                                    {{ props.row.data | moment('L') }}
                                </span>
                            </div>

                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    :type="isStatusButtonType(props.row.situacao)"
                                    size="is-medium"
                                    v-if="props.row.situacao != null || props.row.situacao != ''"
                                >
                                    {{ $t(props.row.situacao.toLowerCase()) }}
                                </b-tag>
                            </div>

                            <div v-else-if="f.key == 'deletar'">
                                <b-button
                                    v-if="props.row.situacao == 'ABERTO'"
                                    type="is-danger"
                                    @click="promptForDelete(props.row)"
                                    icon-right="delete"
                                    position="is-left"
                                    v-tippy 
                                    :title="$t('desativar')"
                                />
                            </div>
                        </b-table-column>
                        <template slot="footer">
                            <th v-for="f in fields" :key="f.key + '-' + f.nome" :id="f.key">
                                <span v-if="f.key == 'nome'"
                                    >{{ acertos.length }} {{ $t('registro') }}</span
                                >
                                <span v-if="f.key == 'valor'"
                                    >{{ getDecimal(valorAdiantamentos, null, true) }}</span
                                >
                                <span v-else></span>
                            </th>
                        </template>
                    </b-table>
                </section>
                <PaginationViewer
                    class="mb-0"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
        <!--Paginação-->
    </div>
</template>

<script>
import AdiantamentoService from '@/services/despesas/AdiantamentoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import Message from '@/models/Message';

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            situacao: {},
            situacoes: [
                { paramQuery: 'EXCLUIDO', label: 'excluidos', id: 0 },
                { paramQuery: 'FECHADO', label: 'fechados', id: 1 },
                { paramQuery: 'ABERTO', label: 'abertos', id: 2 },
                { paramQuery: 'TODOS', label: 'todos', id: 3 },
            ],
            fields: [
                { key: 'colaborador', width: null, sortable: true, label: '', footer: true },
                { key: 'valor', width: 150, sortable: true, label: '', footer: true },
                { key: 'data', width: 120, sortable: true, label: '', footer: false },
                { key: 'situacao', width: 100, sortable: false, label: '', footer: false },
                { key: 'deletar', width: 15, sortable: false, label: '', footer: false },
            ],
            pagination: {
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                currentPage: 1,
                perPage: null,
                totalRows: 0,
            },
            msgs: [],
            adiantamentos: [],
            service: new AdiantamentoService(this.$http, this.$router),
            debouncedOnSearch: Function,
            query: '',
            sort: 'data',
            order: 'desc',
            isLoading: true,
            isEmpty: false,
            valorAdiantamentos: 0,
            delete: null,
            startDate: null,
            endDate: null,
            date: null,
        };
    },
    created() {
        this.situacao = Object.assign(...this.situacoes.filter((s) => s.id == 3));
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados(1);
    },
    methods: {
        carregarDados(currentPage = 1) {
            this.isLoading = true;
            let filtro = {
                startDate: this.startDate
                    ? this.$moment(this.startDate).format('YYYY-MM-DD')
                    : null,
                endDate: this.endDate ? this.$moment(this.endDate).format('YYYY-MM-DD') : null,
                situacao: this.situacao.paramQuery,
            };
            this.service
                .findAll(
                    filtro,
                    this.sort,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.query
                )
                .then(this.mapItems)
                .then((value) => {
                    this.adiantamentos = value;
                    this.isEmpty = this.adiantamentos.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os adiantamentos.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.getTotalValue();
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    idadiantamento: m.idadiantamento,
                    colaborador: m.usuario.nome,
                    valor: m.valor,
                    situacao: m.tipo,
                    data: m.datahorainc,
                    deletar: 'excluir',
                };
            });
            return list;
        },
        promptForDelete(row) {
            this.delete = row;
            this.$root.confirm({
                message: this.$t('msg-confirmacao-desativacao-adiantamento-n', 
                    { n: row.colaborador, v: this.getDecimal(row.valor, null, true) }
                ),
                onConfirm: this.deletarAdiantamento,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        deletarAdiantamento() {
            this.isLoading = true;
            this.service
                .deleteAdiantamentoById(this.delete.idadiantamento)
                .then((_) => {
                    this.$root.showMessage('success', 'msg-success-desativar');
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error('Erro ao remover acerto.', e);
                    this.$root.showMessage('error', 'msg-problema-realizar-acao');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        isStatusButtonType(status) {
            if (status == 'ABERTO') return 'is-danger';
            else if (status == 'FECHADO') return 'is-success';
            else if (status == 'EXCLUIDO') return 'is-warning';
        },
        parseValueSearch(text) {
            //Função para deixar o valor no formato correto para api
            text = text.replace(/[\,]+/g, '.');
            return text;
        },
        onSearch(text) {
            //faz replace da virgula pois a busca no banco precisa ser ocm ponto
            text = this.parseValueSearch(text);
            this.query = this.removeAcentos(text);
            this.pagination.currentPage = 1;
            this.carregarDados(1);
        },
        sortTable(field, order) {
            this.sort = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        updatePagination(value) {
            this.pagination.currentPage = value.currentPage;
            this.pagination.perPage = value.perPage;
            this.carregarDados(this.pagination.currentPage);
        },
        updateSituacao(situacao) {
            if (situacao != null)
                this.situacao = Object.assign(...this.situacoes.filter((s) => s.id == situacao.id));
            else this.situacao = Object.assign(...this.situacoes.filter((s) => s.id == 3));
            this.carregarDados();
        },
        getTotalValue() {
            this.valorAdiantamentos = 0;
            this.adiantamentos.forEach((adiantamento) => {
                this.valorAdiantamentos += adiantamento.valor;
            });
        },
        parseDate(date) {
            return this.$moment(date, 'DD-MM-YYYY').toDate();
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    min-height: 100%;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        min-height: 100%;
        height: inherit;

        .situacao-select div {
            height: 40px;
        }
        .mt-3 {
            margin-top: 5rem !important;
        }
        .rodape-table-info {
            height: 100%;
        }
        .margin-none {
            margin: 0 !important;
        }
        .nav.nav-tabs {
            margin-bottom: 0;
            margin-left: -20px;
            padding-left: 20px;
        }
        .table-tag-full-width {
            width: 100%;
        }
    }
}
</style>
